import { App } from "@alch/dx-entities";
import { UseQueryOptions } from "@tanstack/react-query";
import { trpc } from "@util/trpc/trpcClient";

export const APPS_QUERY_KEY = ["apps"];

export function useApps<T = App[]>(
  opts?: Partial<UseQueryOptions<App[], Error, T>>,
) {
  return trpc.apps.getApps.useQuery(undefined, {
    select: opts?.select,
  });
}

export function useSuspenseApps<T = App[]>(
  opts?: Partial<UseQueryOptions<App[], Error, T>>,
) {
  return trpc.apps.getApps.useSuspenseQuery(undefined, {
    select: opts?.select,
  });
}

export function useCreateApp() {
  const utils = trpc.useUtils();
  return trpc.apps.createApp.useMutation({
    onMutate: async () => {
      await utils.apps.getApps.cancel();
    },
    onSuccess: (newApp) => {
      utils.apps.getApps.setData(undefined, (current) => {
        if (!current) return [newApp] as App[];
        return [...current, newApp];
      });
    },
    onSettled: async () => {
      await utils.apps.getApps.invalidate();
    },
  });
}

export function useUpdateApp() {
  const utils = trpc.useUtils();

  return trpc.apps.updateApp.useMutation({
    onMutate: async () => {
      await utils.apps.getApps.cancel();
    },
    onSuccess: (updatedApp) => {
      utils.apps.getApps.setData(undefined, (apps) => {
        return apps?.flatMap((app) =>
          app.id !== updatedApp.id
            ? app
            : updatedApp.isActive
              ? updatedApp
              : [],
        );
      });
    },
    onSettled: async () => {
      await utils.apps.getApps.invalidate();
    },
  });
}
